import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import BackArrowIcon from 'assets/actionPlan/backArrow.svg';
import SettingsIcon from 'assets/actionPlan/settings.svg';

import {
  getTimeSettings,
  putTimeSetting,
  updateTimeSettings,
} from '../../../features/actions/actionPlanActions';
import { selectTimeSettings } from '../../../features/actions/actionPlanSlice';
import ActionAssignment from '../actionAssignment';
import ActionManagement from '../actionManagement';
import PeriodTypeCard from '../periodTypeCard';
import { timeSettingsSchema } from '../validationSchemas';
import {
  BackIcon,
  Container,
  ContainerCard,
  SettingsIconBlock,
  SettingsImg,
  SettingsSubTitle,
  SettingsTitle,
  SettingsTitleBlock,
  SettingsTopbar,
  Tab,
  TabsContainer,
} from './ActionPlanSettings.styles';

const ActionPlanSettings = () => {
  const dispatch = useDispatch();
  const serverTimeSettings = useSelector(selectTimeSettings);
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('activeTab') || 'Time Settings';
  });
  // const handleTabChange = (tab) => {
  //   setActiveTab(tab);
  //   localStorage.setItem('activeTab', tab);
  //   if (activeTab === 'Time Settings') {
  //     resetToLastSaved();
  //   }
  // };
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('activeTab', tab);

    if (tab === 'Time Settings') {
      resetToLastSaved();
    }
  };

  const [editingCards, setEditingCards] = useState({
    Daily: false,
    Weekly: false,
    Monthly: false,
  });
  const tabs = ['Time Settings', 'Action Management', 'Action Assignment'];
  const [errors, setErrors] = useState({ Daily: false, Weekly: false, Monthly: false });

  const userType = localStorage.getItem('userType');
  const hasManagementAccess = userType === 'General Manager' || userType === 'Super Admin';

  const [cardData, setCardData] = useState({
    Daily: { submissionTime: '', reviewTime: '', reminderValue: 9, id: null },
    Weekly: { submissionTime: '', reviewTime: '', reminderValue: 9, id: null },
    Monthly: { submissionTime: '', reviewTime: '', reminderValue: 9, id: null },
  });

  useEffect(() => {
    dispatch(getTimeSettings());
  }, [dispatch]);

  useEffect(() => {
    if (serverTimeSettings && Array.isArray(serverTimeSettings)) {
      setCardData((prev) => {
        const updatedData = { ...prev };

        serverTimeSettings.forEach((setting) => {
          const type =
            setting.actionPeriodType.charAt(0) +
            setting.actionPeriodType.slice(1).toLowerCase();

          if (updatedData[type] && !editingCards[type]) {
            updatedData[type] = {
              id: setting.id,
              submissionTime: setting.employeeSubmissionTime,
              reviewTime: setting.managerReviewTime,
              reminderValue: setting.reminder,
            };
          }
        });

        return updatedData;
      });
    }
  }, [serverTimeSettings, editingCards]);

  // useEffect(() => {
  //   if (activeTab === 'Action Management' || activeTab === 'Action Assignment') {
  //     dispatch(getActions({ page: 0, size: 100, enabled: true }));
  //   }
  // }, [activeTab, dispatch]);

  useEffect(() => {
    if (activeTab === 'Time Settings' && serverTimeSettings) {
      const resetData = { ...cardData };

      serverTimeSettings.forEach((setting) => {
        const type =
          setting.actionPeriodType.charAt(0) + setting.actionPeriodType.slice(1).toLowerCase();

        if (resetData[type]) {
          resetData[type] = {
            id: setting.id,
            submissionTime: setting.employeeSubmissionTime,
            reviewTime: setting.managerReviewTime,
            reminderValue: setting.reminder,
          };
        }
      });

      setCardData(resetData);
      setErrors({ Daily: false, Weekly: false, Monthly: false });
    }
  }, [activeTab]);

  const resetToLastSaved = () => {
    if (serverTimeSettings && Array.isArray(serverTimeSettings)) {
      const resetData = {
        Daily: { submissionTime: '', reviewTime: '', reminderValue: 9, id: null },
        Weekly: { submissionTime: '', reviewTime: '', reminderValue: 9, id: null },
        Monthly: { submissionTime: '', reviewTime: '', reminderValue: 9, id: null },
      };

      serverTimeSettings.forEach((setting) => {
        const type =
          setting.actionPeriodType.charAt(0) + setting.actionPeriodType.slice(1).toLowerCase();

        if (resetData[type]) {
          resetData[type] = {
            id: setting.id,
            submissionTime: setting.employeeSubmissionTime,
            reviewTime: setting.managerReviewTime,
            reminderValue: setting.reminder,
          };
        }
      });

      setCardData(resetData);
      setEditingCards({
        Daily: false,
        Weekly: false,
        Monthly: false,
      });
      setErrors({ Daily: false, Weekly: false, Monthly: false });
    }
  };

  const handleSaveCard = async (title) => {
    const card = cardData[title];

    try {
      await timeSettingsSchema.validate(card, { abortEarly: false });

      const cleanCard = timeSettingsSchema.cast(card);

      const payload = {
        actionPeriodType: title.toUpperCase(),
        employeeSubmissionTime: cleanCard.submissionTime,
        managerReviewTime: cleanCard.reviewTime,
        reminder: cleanCard.reminderValue,
      };

      setCardData((prev) => ({
        ...prev,
        [title]: {
          ...prev[title],
          submissionTime: cleanCard.submissionTime.toString(),
          reviewTime: cleanCard.reviewTime.toString(),
          reminderValue: cleanCard.reminderValue.toString(),
        },
      }));

      // if (card.id) {
      //   dispatch(putTimeSetting({ id: card.id, timeData: payload }));
      // } else {
      //   dispatch(updateTimeSettings(payload));
      // }
      if (card.id) {
        await dispatch(putTimeSetting({ id: card.id, timeData: payload }));
      } else {
        await dispatch(updateTimeSettings(payload));
      }

      dispatch(getTimeSettings());

      setEditingCards((prev) => ({
        ...prev,
        [title]: false,
      }));
      setErrors((prev) => ({ ...prev, [title]: {} }));
    } catch (err) {
      const validationErrors = {};
      err.inner.forEach((error) => {
        validationErrors[error.path] = error.message;
      });
      setErrors((prev) => ({ ...prev, [title]: validationErrors }));
    }
  };
  const handleInputChange = (title, field, value) => {
    setCardData((prev) => ({
      ...prev,
      [title]: { ...prev[title], [field]: value },
    }));

    setErrors((prev) => ({
      ...prev,
      [title]: { ...prev[title], [field]: undefined },
    }));
  };

  const handleEditCard = (title) => {
    setEditingCards((prev) => ({
      ...prev,
      [title]: true,
    }));
  };

  return (
    <Container>
      <SettingsTopbar>
        {/* <BackIcon src={BackArrowIcon} /> */}
        <SettingsIconBlock>
          <SettingsImg src={SettingsIcon} />
        </SettingsIconBlock>
        <SettingsTitleBlock>
          <SettingsTitle>Settings</SettingsTitle>
          <SettingsSubTitle>
            Overview of KPI performance and action management
          </SettingsSubTitle>
        </SettingsTitleBlock>
      </SettingsTopbar>
      <TabsContainer>
        {tabs.map((tab) => (
          <Tab key={tab} $isActive={activeTab === tab} onClick={() => handleTabChange(tab)}>
            {tab}
          </Tab>
        ))}
      </TabsContainer>
      {activeTab === 'Time Settings' && (
        <>
          <ContainerCard>
            {['Daily', 'Weekly', 'Monthly'].map((title) => (
              <PeriodTypeCard
                key={title}
                title={title}
                subTitle="Action period type"
                data={cardData[title]}
                onChange={(field, val) => handleInputChange(title, field, val)}
                showErrors={errors[title]}
                onSave={() => handleSaveCard(title)}
                onEdit={() => handleEditCard(title)}
                isReadOnly={!hasManagementAccess || !editingCards[title]}
                canEdit={hasManagementAccess}
              />
            ))}
          </ContainerCard>
        </>
      )}

      {activeTab === 'Action Management' && <ActionManagement />}
      {activeTab === 'Action Assignment' && (
        <ActionAssignment onFinish={() => setActiveTab('Action Management')} />
      )}
    </Container>
  );
};

export default ActionPlanSettings;
